import _ from 'lodash';
import { RESOURCES_ACTIONS } from '../constants/action.constants';

const initialState = {};

const resources = (state = initialState, action = {}) => {
  switch (action.type) {
    case RESOURCES_ACTIONS.ADD:
      return { ...state, [action.resourceKey]: action.payload };
    case RESOURCES_ACTIONS.RESET:
      return { ..._.omit(state, action.resourceKey) };
    case RESOURCES_ACTIONS.UPDATE:
      return { ...state, [action.resourceKey]: { ...(state[action.resourceKey] || {}), [action.field]: action.value } };
    default:
      return state;
  }
};

export default resources;
